// extracted by mini-css-extract-plugin
module.exports = {"headingLabel":"headingLabel_headingLabel__jtxJp"};